export default __webpack_public_path__ + "static/media/uploadplus.6cc15867.svg";